<div class="customer-printers" *transloco="let t">
  <app-header [hasDashedLine]="false">{{ t('business-printers') }}</app-header>
  <app-paragraph class="business-equipment-register-info" *ngIf="!viewOnly">
    {{ t('business-equipment-register-info') }}
  </app-paragraph>
  <div id="add-new-printer-line" class="add-new-printer-line" *ngIf="!viewOnly">
    <app-input
      [id]="'business-equipment-serial-add'"
      [label]="equipmentData.labels.serial"
      [control]="serial"
      required
      class="serial-component"
    ></app-input>
    <app-icon-button
      class="button-component"
      id="add-equipment"
      icon="add_box"
      type="submit"
      (clickAction)="editEquipmentNextClick()"
      [disabled]="pendingProductRegistration || checkDisableAddEquipment() || newEquipmentFormGroup!.invalid"
    >
      {{ equipmentData.labels.addEquipment }}
    </app-icon-button>
  </div>
  <app-label *ngIf="saveEquipmentFeedback.hasFeedback()" [isError]="saveEquipmentFeedback.isError">
    {{ t(saveEquipmentFeedback.feedback) }}
  </app-label>
  <app-label *ngIf="serverError" isError>
    {{ equipmentData.labels.invalidSerialErrorMessage }}
  </app-label>
  <app-label *ngIf="equipmentExistsError" isError>
    {{ equipmentData.labels.equipmentExistsError }}
  </app-label>
  <app-label class="feedback-label" isGray *ngIf="feedbackLabel"
    >{{ t(feedbackLabel) }} <mat-icon>check_circle</mat-icon></app-label
  >
  <div *ngIf="pendingProductRegistration && !viewOnly" class="pending-product-registration">
    <app-label class="pending-product-label bold">{{
      t('this-product-still-needs-registered')
    }}</app-label>
    <app-paragraph>
      {{ t('your-printer-is-not-registered-info') }}
    </app-paragraph>
    <div class="unregistered-equipment">
      <app-header
        >{{
          t('modelname-register-data', {
            planModel: newEquipmentFormGroup!.get('planModel')!.getRawValue()
          })
        }}
      </app-header>
      <div class="unregistered-equipment-form">
        <app-input
          id="place-of-purchase"
          [label]="t('place-of-purchase')"
          [control]="registerService.registerEquipmentFormGroup.controls.placeOfPurchase"
          required
        ></app-input>
        <app-input
          id="installation-date"
          [datepicker]="installationDate"
          [label]="t('installation-date')"
          [control]="registerService.registerEquipmentFormGroup.controls.installationDate"
          required
        ></app-input>
        <mat-datepicker #installationDate></mat-datepicker>
      </div>
    </div>
  </div>
  <app-checkbox
    *ngIf="pendingProductRegistration"
    id="register-equipments-agree-checkbox"
    [formGroup]="registerService.registerEquipmentFormGroup"
    abstractFormControlName="agree"
  >
    {{ t('register-equipment-agree-pre-privacy-policy-info') }}
    <a href="{{ this.privacyPolicyLink }}" target="_blank" rel="noopener">{{
      t('privacy-policy') | lowercase
    }}</a>
    {{ t('register-equipment-agree-post-privacy-policy-info') }}
  </app-checkbox>
  <div class="loading" *ngIf="loading" [ngClass]="{ 'not-registration': !isRegistration }">
    <mat-spinner></mat-spinner>
  </div>
  <div class="edit-equipment-button-group" *ngIf="!viewOnly && pendingProductRegistration">
    <app-primary-button id="edit-equipment-cancel-click"
                        stroked
                        (clickAction)="editEquipmentCancelClick()"
                        class="edit-equipment-cancel-button">
      {{t('cancel')}}
    </app-primary-button>
    <app-primary-button id="edit-equipment-next-click"
                        [disabled]="isSaveEquipmentDisabled()"
                        (clickAction)="editEquipmentNextClick()"
                        class="edit-equipment-next-button">
      {{t(editEquipmentNextButtonLabel)}}
    </app-primary-button>
  </div>
  <div class="dashed-line"></div>
  <div class="equipment-content"
       infinite-scroll
       [infiniteScrollDistance]="0.1"
       [scrollWindow]="false"
       [immediateCheck]="true"
       (scrolled)="updatePageEquipmentData()">
    <app-business-equipment-form *ngIf="businessSummary"
          [equipmentData]="equipmentData"
          [phase]="businessEquipmentFormPhase"
          [loading]="equipmentActionLoading || equipmentDataLoading"
          [showAddEquipmentButton]="true"
          [registerEquipmentFormGroup]="registerService.registerEquipmentFormGroup"
          [feedback]="ephemeralFeedback.feedback"
          (deleteEquipmentAction)="deleteEquipment($event)"
          [businessSummary]="businessSummary">
    </app-business-equipment-form>
  </div>
</div>
